import * as api from "../api";

export const SuperAdminService = {
  getPackagesforSuperAdmin,
  createPackage,
  updatePackage,
  changeCompanyStatusforSuperAdmin,
  getCompaniesforSuperAdmin,
  searchPackage,
};

async function getPackagesforSuperAdmin(page, rowsPerPage) {
  try {
    const { data } = await api.getPackagesforSuperAdmin(page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function createPackage(formData) {
  try {
    const { data } = await api.createPackage(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function updatePackage(formData) {
  try {
    const { data } = await api.updatePackage(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function getCompaniesforSuperAdmin(page, rowsPerPage) {
  try {
    const { data } = await api.getCompaniesforSuperAdmin(page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function changeCompanyStatusforSuperAdmin(formData) {
  try {
    const { data } = await api.changeCompanyStatusforSuperAdmin(formData);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}

async function searchPackage(formData, page, rowsPerPage) {
  try {
    const { data } = await api.searchPackage(formData, page, rowsPerPage);
    return { isSuccess: true, data: data };
  } catch (error) {
    return { isSuccess: false, data: error };
  }
}
